import { UnderlyingTag } from 'components/underlying-tag';
import type { Underlying, UnderlyingUnion } from 'models/underlying';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { FC } from 'react';

export interface UnderlyingsLabelFieldProps {
  id?: string;
  e2e?: string;
  value?: Underlying;
  codeType: UnderlyingCodeType;
}

export const UnderlyingsLabelField: FC<UnderlyingsLabelFieldProps> = ({ codeType, e2e, id, value }) => {
  const label = value ? getUnderlyingCode(value, codeType) : '';
  return (
    <div className="underlyings-label-field-component px-2">
      <UnderlyingTag
        dataE2e={e2e ?? id}
        label={label}
        value={value}
        isReadOnly
        className="text-truncate overflow-hidden"
      />
    </div>
  );
};

function getUnderlyingCode(underlying: Underlying, codeType: UnderlyingCodeType): string {
  const underlyingUnion = underlying as unknown as UnderlyingUnion;
  switch (codeType) {
    case 'Bloomberg':
      return underlyingUnion.bloombergTickerCode ?? underlyingUnion.id;
    case 'Ric':
    case 'Reuters':
      return underlyingUnion.reutersCode ?? underlyingUnion.id;
    case 'Isin':
      return underlyingUnion.isin ?? underlyingUnion.id;
    case 'Eliot':
      return underlyingUnion.eliotCode ?? underlyingUnion.id;
    case 'Galaxy':
    case 'PrimaryRootName':
    case 'CurveName':
    default:
      return underlyingUnion.id;
  }
}
